import React from 'react'

import styled from 'styled-components'

import { Alert } from 'app/components/design-system-components'
import * as Display from 'app/components/display/display'
import * as Form from 'app/components/forms/forms'
import { debounce, STANDARD_TIMEOUT } from 'app/helpers/debounce'
import * as snugNotifier from 'app/services/snugNotifier'
import { history } from 'app/shared_components/router'
import { urlTo } from 'app/sm/helpers'
import * as URLHelpers from 'app/utils/url/helpers'

const VTC = 'vtc'
const VTC_LINK = 'virtualtourscreator'
const MatterportURL = 'matterport.com'
export const MatterportVirtualTour = 1
export const VTCVirtualTour = 2
const YouTubeVirtualTour = 3

const AddLink = styled.span`
  font-size: 16px;
  float: left;
  padding: 0px;
  color: #5a9bee;
  position: absolute;
  margin-top: 10px;
  top: 3px;
  text-decoration: underline !important;
  cursor: pointer;
`
const VideoLinkListContainer = styled.div`
  position: relative;
  display: flex;
  width: 240px;
  align-items: center;
  @media (max-width: 576px) {
    width: 70%;
  }

  .mobile-virtual-link-remove {
    font-size: 16px;
    width: 30px;
    padding: 0px;
    margin-left: 16px;
    color: #5a9bee;
    text-decoration: underline !important;
    cursor: pointer;
    @media (max-width: 576px) {
      left: 250px !important;
    }
  }

  span.link-number {
    padding: 20px 15px 25px 0px;
    font-size: 18px;
  }
`

const VideoLinks = ({
  videosNumber,
  videoLinks,
  removeVideoLink,
  updateInputValue,
}) => {
  return (
    <div>
      {Array(videosNumber)
        .fill()
        .map((_, i) => i)
        .map((_, i) => (
          <VideoLinkListContainer>
            <span className="link-number">{`${i + 1}.`}</span>
            <Form.InputTextOptional
              value={videoLinks[i].URL}
              label="Tour Link"
              onChange={(event) => updateInputValue(event, i)}
              labelClass="top18"
              // inputClass="width100 mt0"
              // componentClass="width100"
              isOptional
            />
            <span
              className="mobile-virtual-link-remove"
              onClick={() => removeVideoLink(i)}
            >
              Remove
            </span>
          </VideoLinkListContainer>
        ))}
    </div>
  )
}

class VirtualTour extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      videosNumber: 1,
      videoLinks: [
        {
          URL: '',
          isMain: false,
        },
      ],
      disabled: true,
    }
    this.newVideoLink = this.newVideoLink.bind(this)
    this.removeVideoLink = this.removeVideoLink.bind(this)
    this.updateVideoLink = this.updateVideoLink.bind(this)
  }

  componentDidMount() {
    const { guidDetails, fetchVirtualTourLinks } = this.props
    const { property, agencyGUID } = guidDetails
    if (agencyGUID && property) {
      fetchVirtualTourLinks(agencyGUID, property).then((result) => {
        if (result.length > 0) {
          const videos = result.map((vt) => {
            if (vt.type !== 0) return vt

            const vtObject = this.getVideoObject(vt.URL)
            vt.type = vtObject.type
            vt.URL = vtObject.url

            return vt
          })
          this.setState({
            videoLinks: videos,
            videosNumber: result.length,
            disabled: false,
          })
        }
      })
    }
  }

  goBack = () => {
    const { slug = '' } = this.props
    history.push(urlTo('teamsViewing', { teamSlug: slug }))
  }

  newVideoLink = () => {
    const { videoLinks } = this.state
    videoLinks.push({
      URL: '',
      isMain: false,
    })
    this.setState({ videoLinks })
    const { videosNumber } = this.state
    this.setState({
      videosNumber: videosNumber + 1,
      disabled: true,
    })
  }

  removeVideoLink = (i) => {
    const { videosNumber, videoLinks } = this.state
    if (videosNumber > 0) {
      const newVideos = videoLinks.filter((value, index) => index !== i)
      this.setState({ disabled: false })
      this.setState({
        videosNumber: videosNumber - 1,
        videoLinks: newVideos,
      })
    }
  }

  submit = () => {
    const { videoLinks } = this.state
    const { guidDetails, createVirtualTour } = this.props
    const { property, agencyGUID } = guidDetails
    const requests = videoLinks.filter((tour) => tour.URL !== '')
    if (property && agencyGUID) {
      const payload = {
        requests,
      }
      createVirtualTour(agencyGUID, property, payload)
        .then((result) => {
          if (result.length > 0) {
            this.setState({
              videoLinks: result,
              videosNumber: result.length,
            })
          }
          snugNotifier.success(
            'Successfully added virtual tour link(s) to the property',
          )
        })
        .catch((err) => {
          snugNotifier.error(err)
        })
    }
  }

  updateVideoURL = (data, i) => {
    const { videoLinks } = this.state
    let videoLinksCopy = [...videoLinks]
    videoLinksCopy[i].URL = data.value
    this.setState({
      videoLinks: videoLinksCopy,
    })
    this.updateVideoLink(data, i)
  }

  getVideoObject = (url) => {
    const adjustedYoutubeURL = URLHelpers.adjustYoutubeURL(url)

    if (adjustedYoutubeURL === false) {
      if (url.includes(VTC) || url.includes(VTC_LINK)) {
        return { url, type: VTCVirtualTour }
      } else if (url.includes(MatterportURL)) {
        return { url, type: MatterportVirtualTour }
      } else {
        return { url: '' }
      }
    }
    if (adjustedYoutubeURL) {
      return { url: adjustedYoutubeURL, type: YouTubeVirtualTour }
    }
  }

  updateVideoLink = debounce((data, i) => {
    const { videoLinks } = this.state
    const newURL = data.value
    let videoLinksCopy = [...videoLinks]
    if (videoLinksCopy[i]) {
      if (videoLinksCopy[i].URL === '') {
        return
      }
      const videoObject = this.getVideoObject(newURL)

      if (videoObject.url === '') {
        snugNotifier.error(
          'Invalid YouTube Or VTC OR Matterport URL. Please try entering the URL again.',
        )
        videoLinksCopy[i].URL = ''
        this.setState({
          videoLinks: videoLinksCopy,
          disabled: true,
        })
        return
      }

      videoLinksCopy[i].URL = videoObject.url
      videoLinksCopy[i].type = videoObject.type

      this.setState({
        videoLinks: videoLinksCopy,
        disabled: false,
      })
    }
  }, STANDARD_TIMEOUT)

  render() {
    const { videoLinks, videosNumber, disabled } = this.state
    const {
      isFromOnlistPropertyDisclosures = false,
      virtualViewingAddedNotifyEnquirers = false,
    } = this.props
    return (
      <div className="float-left mt10">
        <h5>Virtual Viewing</h5>
        <div className="mt10 mb20">
          Add Youtube, Virtual Tours Creator or Matterport video links to enable
          virtual tours.
        </div>
        {virtualViewingAddedNotifyEnquirers && (
          <Alert
            variant="blueWithBg"
            my={5}
            showLeftIcon={true}
            leftIconVariant="info"
          >
            Adding a new tour link via this form or via a property feed update
            will notify enquirers.
          </Alert>
        )}
        <VideoLinks
          videosNumber={videosNumber}
          videoLinks={videoLinks}
          removeVideoLink={this.removeVideoLink}
          updateInputValue={this.updateVideoURL}
        />
        <AddLink className="position-relative" onClick={this.newVideoLink}>
          Add another
        </AddLink>
        <div className="bottom-buttons">
          <Display.ModalButtonGroup
            primaryLabel="Save"
            secondaryLabel="Back"
            secondaryButtonType="tertiary"
            primaryAction={this.submit}
            secondaryAction={this.goBack}
            disable={disabled}
            showSecondaryButton={!isFromOnlistPropertyDisclosures}
          />
        </div>
      </div>
    )
  }
}

export default VirtualTour
